<template>
  <div class="dtablerow">

    <!-- Left Panel -->
    <aside id="left-panel" class="left-panel">
      <LeftMenu/>
    </aside><!-- /#left-panel -->
    <!-- Left Panel -->

    <!-- Right Panel -->
    <div id="right-panel" class="right-panel">
      <!-- Header-->
      <header id="header" class="header">
        <div class="header-menu">
          <div class="col-sm-7">
            <MenuToggle/>
            <div class="header-left">
              <HeaderSearch/>
              <HeaderCompanySelector/>
              <HeaderNotification/>
              <HeaderMessages/>
            </div>
          </div>
          <div class="col-sm-5">
            <User/>
            <LngChooser/>
          </div>
        </div>
      </header><!-- /header -->
      <!-- Header-->
      <Breadcrumbs :breadcrumbstitle="breadcrumbstitle" :breadcrumbsData="breadcrumbsData"/>
      <div class="content mt-3">
        <AlertInPage :type="AlertInPage.type" :msg="AlertInPage.msg" :delay="AlertInPage.delay"/>

        <div class="animated fadeIn" v-if="this.hasRole">
          <!-- content place -->


          <div class="col-lg-12">
            <div class="card">
              <div class="card-header">
                <strong>{{$t('OtherIncomeExpense.title')}}</strong>
                <div class="float-right">
                  <router-link :to="{ path: '/otherincomeexpenses'}" class="btn btn-link btn-sm"><i class="fa fa-link"></i> {{$t('OtherIncomeExpenses.title')}}</router-link>
                  &nbsp;
                  <!--<span class="btn btn-primary btn-sm" v-on:click="emptyForNew()"><i class="fa fa-link"></i> {{$t('OtherIncomeExpense.new')}}</span>-->
                </div>
              </div>
              <div class="card-body card-block">
                <!--<AlertInPage type="success" msg="msg" delay="2000"/>-->
                <form action="" method="post" enctype="multipart/form-data" class="form-horizontal">

                  <p>{{ $t('OtherIncomeExpense.attentiontext') }}<br>
                    {{ $t('OtherIncomeExpense.attentiontext2') }}</p>


                  <div class="row">
                    <div class="col-12 col-md-12 d-block d-xs-none d-sm-none d-md-none d-lg-none d-xl-none">
                      <template v-if="data && data.id">
                        <!--<template v-if="!hasAccountant">-->

                        <FileUploader :textInBtn="$t('InvoiceInbound.imageupload')" classNameContainer="d-block overflow-hidden" className="form-control" :dataid="data.id" :datatype="'otherincomeexpense'"
                                      :handlerSuccess="fileUploadHadler"></FileUploader>
                        <!--<template v-if="hasnav && !hasAccountant">-->
                        <!--<div v-if="images.length<1" class="alert alert-danger">-->
                        <!--{{ $t('InvoiceInbound.no_image_error') }}-->
                        <!--</div>-->
                        <!--</template>-->
                        <!--</template>-->
                      </template>

                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-md-12 d-block d-xs-none d-sm-none d-md-none d-lg-none d-xl-none">
                      <div class="col col-12X">
                        <ImageDisplayer classNameContainer="d-block overflow-hidden" :haveToDownload="true" className="form-control" :dataid="data.id" :datatype="'otherincomeexpense'" :handlerSuccess="imageClickHadler"
                                        :cbDataChange="cbDataChange"></ImageDisplayer>
                      </div>
                    </div>
                  </div>


                  <div class="row form-group">
                    <div class="col col-md-3"><label for="title" class=" form-control-label">{{ $t('OtherIncomeExpense.titlerow') }} ({{ $t('validator.required') }})</label></div>
                    <div class="col-12 col-md-9">
                      <InputText
                        id="title" name="data.title" v-model="data.title" v-validate="" hasToKeyboard="auto" value=""
                        :title="$t('businesspartner.titlerow')"
                        placeholder="..." dataLayout="tn" className="form-control mandatory w100X" class="w100" :hasError="errors.has('data.title')"/>
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>


                  <div class="row form-group">
                    <div class="col col-md-3"><label for="dt_make" class=" form-control-label">{{ $t('OtherIncomeExpense.dt_make') }} ({{ $t('validator.required')
                      }})</label>
                    </div>
                    <div class="col-12 col-md-9">
                      <InputText type="DatetimepickerBp"
                                 id="dt_make" name="data.dt_make" v-model="data.dt_make" v-validate="{date_format:'yyyy-MM-dd','isodate':true, required:true}" hasToKeyboard="auto" value=""
                                 :title="$t('OtherIncomeExpense.dt_make')"
                                 placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.dt_make')"
                      />
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>


                  <div class="row form-group infoblock">
                    <div class="col col-md-3"><label for="price_sum_gross" class=" form-control-label">{{ $t('OtherIncomeExpense.price_sum_net_calculator') }} </label></div>
                    <div class="col-12 col-md-9">
                      <div class="row form-group">
                        <div class="col-12 col-md-5">
                        </div>
                        <div class="col-12 col-md-5">
                        </div>
                      </div>


                      <div v-if="Array.isArray(vats) && vats.length==0">
                        <div class="alert alert-warning">{{ $t('OtherIncomeExpense.attentiontext3') }}
                          <router-link :to="{ path: '/vats'}" class="btn btn-link btn-sm"><i class="fa fa-link"></i> {{$t('OtherIncomeExpense.vats')}}</router-link>
                        </div>
                      </div>

                      <div v-if="Array.isArray(vats) && vats.length>0">

                        <div class="row form-group">
                          <div class="col-12 col-md-5">
                            <label class=" form-control-label">{{ $t('OtherIncomeExpense.vat') }}</label><br>
                          </div>
                          <div class="col-12 col-md-1 text-nowrap">
                          </div>
                          <div class="col-12 col-md-5">
                            <label class=" form-control-label">{{ $t('OtherIncomeExpense.price_sum_gross') }} </label>
                          </div>
                        </div>

                        <div v-for="vatelement in vats" class="row form-group">

                          <div class="col-12 col-md-5">
                            <input readonly disabled class="form-control w100X" :name="'data.price_sum_gross'+vatelement.cardinality" :value="vatelement.vat_text"/>
                          </div>
                          <div class="col-12 col-md-1 text-nowrap">
                            <span class="nowrap">---&gt;</span>
                          </div>
                          <div class="col-12 col-md-5 ">
                            <InputText
                              :keyup="fnKeyup" :keydown="fnKeydow" :afterAccept="fnKeyup"
                              :dataprops="vatelement.id+'|vat'"
                              id="price_sum_gross" name="data.price_sum_gross" v-model="price_sum_gross_data[vatelement.id]" v-validate="''" hasToKeyboard="auto"
                              :title="$t('OtherIncomeExpense.price_sum_gross')"
                              placeholder="..." dataLayout="nn" className="form-control mandatory w100X" class="w100" :hasError="errors.has('data.price_sum_gross')"/>

                          </div>

                        </div>

                      </div>


                      <!--<div class="row form-group">-->
                      <!--<div class="col-12 col-md-5">-->
                      <!--<label class=" form-control-label">{{ $t('OtherIncomeExpense.vat') }}</label><br>-->
                      <!--</div>-->
                      <!--<div class="col-12 col-md-5">-->
                      <!--<input readonly disabled class="form-control w100X" name="sum_net_price" v-model="sum_vat_price"/>-->
                      <!--</div>-->
                      <!--</div>-->


                    </div>

                    <div class="col-12">

                      <div class="row form-group">
                        <div class="col-12 col-md-4">
                          <label class=" form-control-label">{{ $t('OtherIncomeExpense.price_sum_net') }}</label><br>
                        </div>
                        <div class="col-12 col-md-4">
                          <label class=" form-control-label">{{ $t('OtherIncomeExpense.price_vat') }}</label><br>
                        </div>
                        <div class="col-12 col-md-4">
                          <label class=" form-control-label">{{ $t('OtherIncomeExpense.price_sum_gross') }}</label><br>
                        </div>
                        <!--<div class="col-12 col-md-3">-->
                        <!--<label class=" form-control-label">{{ $t('OtherIncomeExpense.copy') }} </label>-->
                        <!--</div>-->
                      </div>


                      <div class="row form-group">

                        <!--<div class="col-12 col-md-5"></div>-->
                        <div class="col-12 col-md-4">
                          <!--<input readonly disabled class="form-control w100X" name="sum_net_price" v-model="sum_net_price"/>-->

                          <InputText
                            id="price_sum_net" name="data.price_sum_net" v-model="data.price_sum_net" v-validate="'decimal'" hasToKeyboard="auto" value=""
                            :title="$t('OtherIncomeExpense.price_sum_net')"
                            :readonly="'true'" :disabled="'true'"
                            placeholder="..." dataLayout="nn" className="form-control mandatory w100X" class="w100" :hasError="errors.has('data.price_sum_net')"/>

                        </div>
                        <div class="col-12 col-md-4">
                          <!--<input readonly disabled class="form-control w100X" name="sum_vat_price" v-model="sum_vat_price"/>-->

                          <InputText
                            id="price_vat" name="data.price_vat" v-model="data.price_vat" v-validate="'decimal'" hasToKeyboard="auto" value=""
                            :title="$t('OtherIncomeExpense.price_vat')"
                            :readonly="'true'" :disabled="'true'"
                            placeholder="..." dataLayout="nn" className="form-control mandatory w100X" class="w100" :hasError="errors.has('data.price_vat')"/>

                        </div>
                        <div class="col-12 col-md-4">
                          <!--<input readonly disabled class="form-control w100X" name="sum_vat_price" v-model="sum_gross_price"/>-->

                          <InputText
                            id="price_sum" name="data.price_sum" v-model="data.price_sum" v-validate="'decimal'" hasToKeyboard="auto" value=""
                            :title="$t('OtherIncomeExpense.price_sum')"
                            :readonly="'true'" :disabled="'true'"
                            placeholder="..." dataLayout="nn" className="form-control mandatory w100X" class="w100" :hasError="errors.has('data.price_sum')"/>


                        </div>
                        <!--<div class="col-12 col-md-3">-->
                        <!--<button type="button" class="btn btn-primary btn-sm" v-on:click="doCopy">-->
                        <!--<i class="fa fa-save"></i> {{$t('OtherIncomeExpense.copyprice')}}-->
                        <!--</button>-->
                        <!--</div>-->

                      </div>

                    </div>

                  </div>


                  <div class="row form-group     d-none d-xs-block d-sm-block d-md-block d-lg-block d-xl-block">
                    <div class="col col-4">
                      <ImageDisplayer classNameContainer="d-block overflow-hidden" :haveToDownload="true" className="form-control" :dataid="data.id" :datatype="'otherincomeexpense'"
                                      :handlerSuccess="imageClickHadler"></ImageDisplayer>
                    </div>
                    <div class="col col-8">
                      <div class="row">
                        <div class="col-12">
                          <div class="row form-group">
                            <div class="col col col-6"><label class=" form-control-label">{{ $t('global.fileupload') }}</label>
                            </div>
                            <div class="col col col-6">
                              <FileUploader :textInBtn="$t('InvoiceInbound.imageupload')" classNameContainer="d-block overflow-hidden" className="form-control" :dataid="data.id" :datatype="'otherincomeexpense'"
                                            :handlerSuccess="fileUploadHadler"></FileUploader>
                            </div>
                            <div class="col col-12">
                              <!--<ImageDisplayer classNameContainer="d-block overflow-hidden" className="form-control" :dataid="data.id" :datatype="'otherincomeexpense'" :handlerSuccess="imageClickHadler"></ImageDisplayer>-->
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--<div class="row">-->
                      <!--<div class="col-12">-->
                      <!--<span v-for="image in images" class="image">{{image}}</span>-->
                      <!--</div>-->
                      <!--</div>-->
                      <hr>
                    </div>
                  </div>

                  <!--<div class="col-12 col-md-6">-->
                  <!--<div class="row form-group">-->
                  <!--<div class="col col-md-3"><label for="vat" class=" form-control-label">{{ $t('StoDocuments.vat') }}-->
                  <!--&lt;!&ndash;({{ $t('validator.required') }})&ndash;&gt;-->
                  <!--</label>-->
                  <!--</div>-->
                  <!--<div class="col-12 col-md-9">-->
                  <!--<select id="vat" :name="'vat'"-->
                  <!--v-model="vat" v-validate="'required'"-->
                  <!--:title="$t('StoDocuments.stores')"-->
                  <!--class="form-control mandatory w100" :hasError="errors.has('data.vat')"-->
                  <!--&gt;-->
                  <!--&lt;!&ndash;:readonly="Number(viewRole)===0"&ndash;&gt;-->
                  <!--&lt;!&ndash;:disabled="Number(viewRole)===0"&ndash;&gt;-->
                  <!--&lt;!&ndash;cardinality": "27.000", "vat_text&ndash;&gt;-->
                  <!--<option v-for="option in vats" :value="''+option.cardinality">{{option.vat_text }}</option>&lt;!&ndash;+ " ("+option.cardinality+" %)"&ndash;&gt;-->
                  <!--</select>-->
                  <!--<small class="form-text text-muted"></small>-->
                  <!--</div>-->
                  <!--</div>-->
                  <!--</div>-->

                  <!--<div class="row form-group">-->
                  <!--<div class="col col-md-3"><label for="price_sum_gross" class=" form-control-label">{{ $t('OtherIncomeExpense.price_sum_netCalculator') }} </label></div>-->
                  <!--<div class="col-12 col-md-9">-->
                  <!---->
                  <!--<small class="form-text text-muted"></small>-->
                  <!--</div>-->
                  <!--</div>-->


                  <!--<div class="row form-group">-->
                  <!--<div class="col col-md-3"><label for="price_sum_net" class=" form-control-label">{{ $t('OtherIncomeExpense.price_sum_net') }} ({{ $t('validator.required') }})</label></div>-->
                  <!--<div class="col-12 col-md-9">-->
                  <!--<InputText-->
                  <!--id="price_sum_net" name="data.price_sum_net" v-model="data.price_sum_net" v-validate="'decimal'" hasToKeyboard="auto" value=""-->
                  <!--:title="$t('businesspartner.price_sum_net')"-->
                  <!--placeholder="..." dataLayout="nn" className="form-control mandatory w100X" class="w100" :hasError="errors.has('data.price_sum_net')"/>-->
                  <!--<small class="form-text text-muted"></small>-->
                  <!--</div>-->
                  <!--</div>-->
                  <!--<div class="row form-group">-->
                  <!--<div class="col col-md-3"><label for="price_sum_net" class=" form-control-label">{{ $t('OtherIncomeExpense.price_vat') }} ({{ $t('validator.required') }})</label></div>-->
                  <!--<div class="col-12 col-md-9">-->
                  <!--<InputText-->
                  <!--id="price_vat" name="data.price_vat" v-model="data.price_vat" v-validate="'decimal'" hasToKeyboard="auto" value=""-->
                  <!--:title="$t('businesspartner.price_vat')"-->
                  <!--placeholder="..." dataLayout="nn" className="form-control mandatory w100X" class="w100" :hasError="errors.has('data.price_vat')"/>-->
                  <!--<small class="form-text text-muted"></small>-->
                  <!--</div>-->
                  <!--</div>-->
                  <!--<div class="row form-group">-->
                  <!--<div class="col col-md-3"><label for="price_sum_net" class=" form-control-label">{{ $t('OtherIncomeExpense.price_sum') }} ({{ $t('validator.required') }})</label></div>-->
                  <!--<div class="col-12 col-md-9">-->
                  <!--<InputText-->
                  <!--id="price_sum" name="data.price_sum" v-model="data.price_sum" v-validate="'decimal'" hasToKeyboard="auto" value=""-->
                  <!--:title="$t('businesspartner.price_sum')"-->
                  <!--placeholder="..." dataLayout="nn" className="form-control mandatory w100X" class="w100" :hasError="errors.has('data.price_sum')"/>-->
                  <!--<small class="form-text text-muted"></small>-->
                  <!--</div>-->
                  <!--</div>-->

                  <!--<div class="row form-group">-->
                  <!--<div class="col col-md-3"><label for="from_name" class=" form-control-label">{{ $t('OtherIncomeExpense.from_name') }} ({{ $t('validator.required') }})</label></div>-->
                  <!--<div class="col-12 col-md-9">-->
                  <!--<InputText-->
                  <!--id="from_name" name="data.from_name" v-model="data.from_name" v-validate="" hasToKeyboard="auto" value=""-->
                  <!--:title="$t('businesspartner.from_name')"-->
                  <!--placeholder="..." dataLayout="nn" className="form-control mandatory w100X" class="w100" :hasError="errors.has('data.from_name')"/>-->
                  <!--<small class="form-text text-muted"></small>-->
                  <!--</div>-->
                  <!--</div>-->

                  <!--<div class="row form-group">-->
                  <!--<div class="col col-md-3"><label for="text" class=" form-control-label">{{ $t('OtherIncomeExpense.text') }} ({{ $t('validator.required') }})</label></div>-->
                  <!--<div class="col-12 col-md-9">-->
                  <!--<InputText-->
                  <!--id="text" name="data.text" v-model="data.text" v-validate="" hasToKeyboard="auto" value=""-->
                  <!--:title="$t('businesspartner.text')"-->
                  <!--placeholder="..." dataLayout="nn" className="form-control mandatory w100X" class="w100" :hasError="errors.has('data.text')"/>-->
                  <!--<small class="form-text text-muted"></small>-->
                  <!--</div>-->
                  <!--</div>-->


                  <!--<hr>-->
                  <!--<div class="row form-group">-->
                  <!--<div class="col col-md-3"><label for="deleted" class=" form-control-label">{{ $t('global.deleted') }}</label></div>-->
                  <!--<div class="col-12 col-md-9">-->
                  <!--<select class="form-control" id="deleted" v-model="data.deleted" name="data.deleted">-->
                  <!--<option value="0">{{$t('global.no')}} </option>-->
                  <!--<option value="1">{{$t('global.yes')}}</option>-->
                  <!--</select>-->
                  <!--</div>-->
                  <!--</div>-->

                </form>
              </div>
              <div class="card-footer">
                <button type="submit" class="btn btn-primary btn-sm" v-on:click="save()">
                  <i class="fa fa-save"></i> {{$t('OtherIncomeExpense.save')}}
                </button>
                <template v-if="images.length===0">
                  &nbsp;<button type="button" class="btn btn-danger btn-sm" v-on:click="doDelete">
                    <i class="fa fa-ban"></i> {{$t('global.delete')}}
                  </button>
                </template>
                <!--<button type="reset" class="btn btn-danger btn-sm">-->
                <!--<i class="fa fa-ban"></i> Reset-->
                <!--</button>-->
              </div>
            </div>

          </div>


        </div><!-- .animated -->

        <div class="animated fadeIn" v-if="!this.hasRole">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header">
                <strong>{{$t('global.roleproblemcheckstitle')}}</strong>
                <div class="float-right">
                </div>
              </div>
              <div class="card-body card-block">{{$t('global.roleproblemchecks')}}</div>
            </div>
          </div>
        </div><!-- .animated -->
        <div class="animated fadeIn" v-if="this.hasRole&&!this.hasCompany">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header">
                <strong>{{$t('global.roleproblemnocompanytitle')}}</strong>
                <div class="float-right">
                </div>
              </div>
              <div class="card-body card-block">{{$t('global.roleproblemnocompany')}}</div>
            </div>
          </div>
        </div><!-- .animated -->

      </div><!-- .content -->
    </div><!-- /#right-panel -->
    <!-- Right Panel -->
  </div>

</template>

<script>

  // @ is an alias to /src
  import LeftMenu from '@/components/LeftMenu.vue';
  import HeaderSearch from '@/components/HeaderSearch.vue';
  import HeaderCompanySelector from '@/components/HeaderCompanySelector.vue';
  import HeaderNotification from '@/components/HeaderNotification.vue';
  import HeaderMessages from '@/components/HeaderMessages.vue';
  import User from '@/components/User.vue';
  import LngChooser from '@/components/LngChooser.vue';
  import Breadcrumbs from '@/components/Breadcrumbs.vue';
  import AlertInPage from '@/components/AlertInPage.vue';
  import Api from '@/api/Api';
  import Helper from '@/helper/Helper';
  import HelperRole from '@/helper/HelperRole';
  import MenuToggle from '@/components/MenuToggle.vue';
  import InputText from '@/components/InputText.vue';
  import ImageDisplayer from '@/components/ImageDisplayer.vue';
  import FileUploader from '@/components/FileUploader.vue';


  //  id_store 	wsid 	text
  export default {
    name: 'OtherIncomeExpense',
    data() {
      return {
        Helper: Helper

        , data: {
          // cardinality 	vat_text 	deleted
          "id": "",
          "type": "CASHREGISTER",
          "direction": "OUTBOUND",
          "title": "",
          "text": "",
          "dt_make": "",
          "price_sum_net": "",
          "price_vat": "",
          "price_gross": "",
          "from_name": "",
        }
        , dataBase: { // need for change without save
          "id": "",
          "type": "CASHREGISTER",
          "direction": "OUTBOUND",
          "title": "",
          "text": "",
          "dt_make": "",
          "price_sum_net": "",
          "price_vat": "",
          "price_gross": "",
          "from_name": "",
        }
        , AlertInPage: {
          type: "", // primary secondary success danger warning info light dark
          msg: "",
          msgPre: "",
          msgPost: "",
          delay: 2500,
        }
        , breadcrumbstitle: 'OtherIncomeExpense.title'
        , breadcrumbsData: [
          {
            'title': "OtherIncomeExpenses.title",
            'url': "otherincomeexpenses",
          },
          {
            'title': "OtherIncomeExpense.title",
          }
        ]
        , images: []
        , HelperRole: HelperRole
        , hasRole: false
        , hasCompany: false
        , state: {}
        , stateHash: ""
        , vats: []
        , vat: ""
        , price_sum_gross: ""
        , price_sum_net_counted: ""
        , price_sum_gross_data: []
        , price_sum_gross_vat_data: []
        , sum_net_price: 0
        , sum_vat_price: 0
        , sum_gross_price: 0
      };
    },
    props: {
      id: String,
    },
    watch: {
      "$store.state.healthCheckHash": function (newData, oldData) {
        const modul = this;
        if (newData !== oldData) {
          modul.state = Object.assign({}, modul.$store.state);
          modul.handleRights();
          this.getElement();
        }
      },
      'hasRole': function (newVal, oldVal) {
        const modul = this;
        if (newVal && !oldVal) {
          if (modul.hasRole && modul.hasCompany) {
            modul.init();
          }
        }
      },

      '$route.params': function (newdata, olddata) {
        if (this.$route.params.id) {
          this.id = newdata;
          this.getElement();
        } else {
          this.id = void 0;
        }
      }
    },
    mounted() {
      const modul = this;
      modul.handleRights();
    },
    methods: {
      cbDataChange(data){
        const modul = this;
        modul.images = data
        console.log("cbDataChange - data");
        console.log(data);
      },
      fileUploadHadler(e){
        console.log("e");
        console.log(e);
      },
      imageClickHadler(e){
        console.log("e");
        console.log(e);
      },
      fnKeydow: function (e, x) {
        const modul = this;
        console.log("fnKeydow");
        window.setTimeout(function () {
          modul.fnKey(e, x);
        }, 100);
      }
      ,
      fnKeyup: function (e, x) {
        const modul = this;
        console.log("fnKeyup");
        window.setTimeout(function () {
          modul.fnKey(e, x);
        }, 100);
      }
      ,
      fnKey: function (e, x) {
        const modul = this;
        const arrProp = e.target.dataset.props.split("|");
        const rowIndex = arrProp[0];
        const rowField = arrProp[1];
        console.log(rowIndex)
        console.log(rowField)
        modul.doCounting();
      },
      doCounting(){
        const modul = this;
        let sum_net_price = 0;
        let sum_vat_price = 0;
        let sum_gross_price = 0;
        Array.prototype.forEach.call(Object.keys(modul.price_sum_gross_data), function (e, i) {
          const vatElement = Helper.getObjectByIdFromObjectArray(modul.vats, e);
          const net = Helper.Number(modul.price_sum_gross_data[e]) / (1 + (Helper.Number(vatElement.cardinality) / 100));
          const vat = Helper.Number(modul.price_sum_gross_data[e]) - net;
          const gross = Helper.Number(modul.price_sum_gross_data[e]);

          sum_net_price += net;
          sum_vat_price += vat;
          sum_gross_price += gross;
        })
        modul.sum_net_price = Helper.getRoundedNumber(sum_net_price, 3);
        modul.sum_vat_price = Helper.getRoundedNumber(sum_vat_price, 3);
        modul.sum_gross_price = Helper.getRoundedNumber(sum_gross_price, 3);
        modul.doCopy()
      },
      doCopy(){
        const modul = this;
        modul.data.price_sum_net = modul.sum_net_price;
        modul.data.price_vat = modul.sum_vat_price;
        modul.data.price_sum = modul.sum_gross_price;
      },
      handleRights(){
        const modul = this;
        modul.state = Object.assign({}, modul.$store.state);
        if (HelperRole.hasRights(modul.state, [14], [16, 20])) {
          modul.hasRole = true;
        }
        if (modul.state.id_company) {
          modul.hasCompany = true;
        }
        if (modul.hasRole && modul.hasCompany) {
//          modul.init();
        }
      },
      init(){
        const modul = this;
        modul.getElement();
        modul.getVats();
      },
      getElement(){
        const modul = this;
        let id = 0;
        try {
          id = (this.$route.params.id);
          if (id) {
            modul.AlertInPage.msg = "form.in_progress";
            modul.AlertInPage.type = "warning";
            Api.getOtherIncomeExpense({id: id, id_company: modul.state.id_company}).then(function (res) {
              console.log(res);
              if (res && res.result && res.data) {
                modul.data = res.data;
                modul.AlertInPage.msg = "";
              } else {
//                modul.data = Object.assign({}, modul.dataBase);
                modul.hasRole = false;
                modul.AlertInPage.msg = "form.error";
                modul.AlertInPage.type = "danger";
                setTimeout(function (e) {
                  modul.AlertInPage.msg = "";
//                  modul.$router.push({path: "/otherincomeexpenses"})
                }, Number(2000));
              }
            }, function (e) {
              modul.AlertInPage.msg = "form.error";
              modul.AlertInPage.type = "danger";
              setTimeout(function (e) {
                modul.AlertInPage.msg = "";
              }, Number(modul.AlertInPage.delay));
            });
          }
        } catch (e) {
          console.log(e);
        }
      },
      emptyForNew(){
        this.data = Object.assign({}, this.dataBase);
//        this.$router.push({name: "/otherincomeexpense"})
      },
      getVats(){
        const modul = this;
        modul.AlertInPage.msg = "form.in_progress";
        modul.AlertInPage.type = "warning";
        Api.getVats({id_company: modul.$store.state.id_company}).then(function (res) {
          if (res && res.result) {
            modul.vats = Array.from(res.data);
            if (modul.vats && modul.vats.length === 1) {
              modul.vat = modul.vats[0].cardinality;
            } else {

            }
          }
          modul.AlertInPage.msg = "";
        }, function (e) {
          modul.AlertInPage.msg = "form.error";
          modul.AlertInPage.type = "danger";
          setTimeout(function (e) {
            modul.AlertInPage.msg = "";
          }, Number(modul.AlertInPage.delay));
        });
      },
      doDelete(){
        const modul = this;
        const fnCb = function () {
          const req = {};
          req.id = modul.data.id;
          req.id_company = modul.state.id_company;
          modul.AlertInPage.msg = "form.in_progress";
          modul.AlertInPage.type = "warning";

          Api.deleteOtherIncomeExpense(req).then(function (res) {

            if (res && res.result) {
              modul.AlertInPage.msg = "global.success";
              modul.AlertInPage.type = "success";
              setTimeout(function (e) {
                modul.AlertInPage.msg = "";
              }, Number(5000));

              setTimeout(function (e) {
                modul.$router.push({
                  path: '/emptypage'
                });
                setTimeout(function (e) {
                  modul.$router.push({
                    path: '/otherincomeexpenses'
//                    name: "storevenue", params: {id: modul.data.id}
                  });
                }, 10);
              }, 300);

            } else {
              modul.AlertInPage.msg = "global.error";
              modul.AlertInPage.type = "danger";
              setTimeout(function (e) {
                modul.AlertInPage.msg = "";
              }, Number(5000));
              modul.AlertInPage.msg = "";

            }
          }, function (e) {
            modul.AlertInPage.msg = "";

          })

        };

        modul.$eventBus.$emit('modal', {
          type: "confirm",
          msgTitle: "",
          tmsgTitle: "question",
          msgText: "",
          tmsgText: "areyousuredelete",
          fnCancel: function () {
            console.log('fnCancel')
          },
          fnConfirm: function () {
            console.log('fnConfirm')
            fnCb()
          }
        });

      },
      save(){
        const modul = this;
        modul.$validator.validateAll().then((result) => {
          if (result) {
            const req = {};
            req.data = Helper.makeFilteredObjectByKeys(modul.data, ["id", "type", "direction", "title", "dt_make", "price_sum_net", "price_sum", "price_vat", "from_name"]);
            req.id_company = modul.state.id_company;
            const alertId = Math.random();
            modul.$eventBus.$emit('globalAlert', {
              id: alertId,
              type: "warning",
              msgPreInner: "",
              msg: "form.in_progress",
              msgPostInner: "",
              delay: 50000
            });

//            modul.AlertInPage.msg = "form.in_progress";
//            modul.AlertInPage.type = "warning";
            Api.saveOtherIncomeExpense(req).then(function (res) {
              if (res && res.result) {
                if (res && res.data.id) {
                  modul.data.id = res.data.id;
                }
                modul.$eventBus.$emit('globalAlert', {
                  id_delete: alertId,
                  type: "success",
                  msgPreInner: "",
                  msg: "form.save_succes",
                  msgPostInner: "",
                  delay: 5000
                });
//                modul.AlertInPage.msg = "form.save_succes";
//                modul.AlertInPage.type = "success";
//                setTimeout(function (e) {
//                  modul.AlertInPage.msg = "";
//                  modul.$router.push({path: "/otherincomeexpenses"})
//                }, Number(1000));
              } else {
                modul.$eventBus.$emit('globalAlert', {
                  id_delete: alertId,
                  type: "danger",
                  msgPreInner: "",
                  msg: "form.save_error",
                  msgPostInner: "",
                  delay: 5000
                });

//                modul.AlertInPage.msg = "form.save_error";
//                modul.AlertInPage.type = "danger";
//                setTimeout(function (e) {
//                  modul.AlertInPage.msg = "";
//                }, Number(modul.AlertInPage.delay));
              }
            }, function (e) {
              modul.$eventBus.$emit('globalAlert', {
                id_delete: alertId,
                type: "danger",
                msgPreInner: "",
                msg: "form.save_error",
                msgPostInner: "",
                delay: 5000
              });
//              modul.AlertInPage.msg = "form.save_error";
//              modul.AlertInPage.type = "danger";
//              setTimeout(function (e) {
//                modul.AlertInPage.msg = "";
//              }, Number(modul.AlertInPage.delay));
            });

          } else {
            modul.$eventBus.$emit('globalAlert', {
//              id_delete: alertId,
              type: "danger",
              msgPreInner: "",
              msg: "form.validation_error",
              msgPostInner: "",
              delay: 5000
            });

//            modul.AlertInPage.msg = "form.save_error";
//            modul.AlertInPage.type = "danger";
          }
        });
      }
    },
    components: {
      LeftMenu,
      HeaderSearch,
      HeaderCompanySelector,
      HeaderNotification,
      HeaderMessages,
      User,
      LngChooser,
      Breadcrumbs,
      AlertInPage,
      MenuToggle,
      InputText,
      FileUploader,
      ImageDisplayer
    },
  };
</script>








